import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll the window to the top whenever the route pathname changes.
 * React Router v6+ does not do this by default; without it, navigating from
 * the footer of one page to another can leave the user mid-page on the
 * destination route — making short pages look empty.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}
